(() => {
  const styleDe = (piste) => piste.dataset.indicatorStyle || 'bar';

  const pastilles = (piste, index, total) => {
    let hote = piste.nextElementSibling;
    if (!hote || !hote.classList.contains('hf-slider-progress__dots')) {
      hote = document.createElement('div');
      hote.className = 'hf-slider-progress__dots';
      piste.insertAdjacentElement('afterend', hote);
    }
    if (hote.childElementCount !== total) {
      hote.textContent = '';
      for (let i = 0; i < total; i += 1) {
        const point = document.createElement('span');
        point.className = 'hf-slider-progress__dot';
        hote.appendChild(point);
      }
    }
    Array.from(hote.children).forEach((point, i) => {
      point.dataset.active = String(i === index);
    });
  };

  const surveillerLargeur = (piste, bar) => {
    if (piste._hfObs || typeof ResizeObserver === 'undefined') return;
    piste._hfObs = new ResizeObserver(() => {
      if (piste.clientWidth <= 0) return;
      piste._hfObs.disconnect();
      piste._hfObs = null;
      const dernier = bar._hfDernier;
      if (dernier) window.hfSliderIndicator(bar, dernier.index, dernier.total);
    });
    piste._hfObs.observe(piste);
  };

  window.hfSliderIndicator = (bar, index, total) => {
    if (!bar) return;
    const piste = bar.parentElement;
    if (!piste || !total || total < 1) return;

    const i = Math.max(0, Math.min(total - 1, index));
    bar._hfDernier = { index: i, total };
    const ratio = total > 1 ? i / (total - 1) : 1;
    const style = styleDe(piste);

    if (style === 'dots') {
      pastilles(piste, i, total);
      return;
    }

    if (style === 'slider') {
      const largeurPiste = piste.clientWidth;
      if (largeurPiste <= 0) {
        surveillerLargeur(piste, bar);
        return;
      }
      const largeur = Math.max(16, largeurPiste / total);
      bar.style.setProperty('width', largeur + 'px', 'important');
      bar.style.transform = 'translateX(' + (largeurPiste - largeur) * ratio + 'px)';
      return;
    }

    bar.style.transform = '';
    bar.style.setProperty('width', ((i + 1) / total) * 100 + '%', 'important');
  };
})();
